import { render } from 'react-dom'
import AddToGarage from '../../components/AddToGarage/AddToGarage'

document.addEventListener('DOMContentLoaded', () => {
  const targetContainer = document.getElementById('add-to-garage')

  if (targetContainer) {
    render(<AddToGarage />, targetContainer)
  }
})
